/**
 * Fetch job types successful action.
 */
import JobType from "../../../model/job/JobType";

export const JOB_TYPE_FETCHED = "JOB_TYPE_FETCHED";
export type JOB_TYPE_FETCHED = { jobTypes: Array<JobType> }

/**
 * Update job type successful action.
 */
export const JOB_TYPE_UPDATED = "JOB_TYPE_UPDATED";
export type JOB_TYPE_UPDATED = { jobType: JobType }

